import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/policia.png";
import Imagen2 from "../../../images/modulo2/pista.png";
import Imagen3 from "../../../images/modulo2/camion.png";
import Imagen4 from "../../../images/modulo2/construccion.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import InputText from "../../../components/InputText";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "D" },
    ans2: { value: "", valid: "", correctValue: "B" },
    ans3: { value: "", valid: "", correctValue: "A" },
    ans4: { value: "", valid: "", correctValue: "C" },
  });
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[3];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[4].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[4].path}`,
    titlePrev: `${modulo2.content[0].activities[2].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[2].path}`,
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value.toUpperCase() },
    });
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 4</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          La municipalidad es la institución encargada de cuidar y desarrollar
          la ciudad.
        </li>
        <li>
          En el recuadro se describen algunos de los servicios que realizan las
          municipalidades.
        </li>
        <li>
          Escribe la letra que aparece junto a cada servicio en la imagen
          correspondiente.
        </li>
      </ul>
      <Card>
        <div className="row g-4 g-xs-2">
          <div className="mx-2 col-auto">A. Recoger la basura</div>
          <div className="mx-2 col-auto">B. Construir obras públicas</div>
          <div className="mx-2 col-auto">
            C. Otorgar permisos de construcción
          </div>
          <div className="mx-2 col-auto">D. Brindar seguridad</div>
        </div>
      </Card>
      <div className="row activities-content mt-5">
        <div className="col-lg-3 col-md-6 col-xs-12 mb-4">
          <div className="d-flex align-items-center mb-1">
            <InputText
              answer={answers.ans1}
              onChangeInput={handleAnswers}
              name="ans1"
            />{" "}
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-3 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center mb-1">
            <InputText
              answer={answers.ans2}
              onChangeInput={handleAnswers}
              name="ans2"
            />
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-3 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center mb-1">
            <InputText
              answer={answers.ans3}
              onChangeInput={handleAnswers}
              name="ans3"
            />{" "}
          </div>
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-3 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center mb-1">
            <InputText
              answer={answers.ans4}
              onChangeInput={handleAnswers}
              name="ans4"
            />
          </div>
          <img src={Imagen4} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo2.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Explique que las municipalidades, como parte de
          su función de cuidar y desarrollar la ciudad, realizan diferentes
          trabajos. Lea las frases en el recuadro y explique de qué se trata
          cada una de esas actividades. Ayude a resolver la actividad si es que
          hay dudas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
